import { render, staticRenderFns } from "./DefManager.vue?vue&type=template&id=3a170e3a&scoped=true&"
import script from "./DefManager.vue?vue&type=script&lang=js&"
export * from "./DefManager.vue?vue&type=script&lang=js&"
import style0 from "./DefManager.vue?vue&type=style&index=0&id=3a170e3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a170e3a",
  null
  
)

export default component.exports